export type DocumentShareStatus = 'Pending' | 'Accepted' | 'Rejected' | 'Revoked';

export type ShareViewPolicy = 'Standard' | 'InAppProtected';

export type ValidateEmailResponse = {
  valid: boolean;
  maskedDisplayName?: string | null;
};

export type CreateDocumentShareRequest = {
  documentId: string;
  recipientEmail?: string;
  recipientUserId?: string;
  viewPolicy?: ShareViewPolicy;
  message?: string | null;
};

export type RejectDocumentShareRequest = {
  reason?: string | null;
};

export type DocumentShareDto = {
  id: string;
  documentId: string;
  documentName: string;
  documentContentType?: string | null;
  sourcePageCount: number;
  senderUserId: string;
  senderDisplayName: string;
  recipientUserId: string;
  recipientDisplayName: string;
  status: DocumentShareStatus;
  viewPolicy: ShareViewPolicy;
  message?: string | null;
  rejectionReason?: string | null;
  acceptedAt?: string | null;
  rejectedAt?: string | null;
  revokedAt?: string | null;
  lastViewedAt?: string | null;
  acceptanceExpiresAt?: string | null;
  createdAt: string;
  /** False while an accepted InAppProtected share still awaits its generated copy. */
  protectedCopyReady?: boolean;
};

export type DocumentShareListItemDto = {
  id: string;
  documentId: string;
  documentName: string;
  documentContentType?: string | null;
  sourcePageCount: number;
  counterpartyDisplayName: string;
  counterpartyUserId: string;
  status: DocumentShareStatus;
  viewPolicy: ShareViewPolicy;
  message?: string | null;
  createdAt: string;
  lastViewedAt?: string | null;
  isArchived?: boolean;
  canCancel?: boolean;
  conversationId?: string | null;
};

export const REQUIRES_NATIVE_APP_CODE = 'REQUIRES_NATIVE_APP';
